import React, { useEffect, useState } from "react";
import ConfirmDialog from "../../../../components/actionDialogs/confirmDialog";
import Loader from "../../../../components/loader/loader";
import Snackbar from "../../../../components/snackbar/snackbar";
import CustomTable from "../../../../components/table/table";
import { admin_banners_list, admin_banner_delete } from "../../admin.api";
import ManageBanner from "./manage/manage";
import "./view.css";
import jwtDecode from "jwt-decode";
export default function View(props) {
  let adminType = Number(jwtDecode(props.state.payload).user_type);
  const assetBaseUrl = (process.env.REACT_APP_BASE_URL || "").replace(
    /\/api\/?$/,
    ""
  );

  const [data, setdata] = useState([]);
  const [addNew, setAddNew] = useState(false);
  const [formData, setFormData] = useState({});
  const [edit, setEdit] = useState(false);
  const [view, setView] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [isActive, setIsActive] = useState(true);
  //for delete
  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  //////////
  const handleEventList = () => {
    setIsActive(true);
    admin_banners_list().then((res) => {
      let tempData = res.data;
      tempData.forEach((item, index) => {
        item["slno"] = index + 1;
      });
      setdata(tempData);
      setIsActive(false);
    });
  };
  useEffect(() => {
    handleEventList();
  }, []);
  const handleAddNew = () => {
    setAddNew(true);
    setView(false);
  };
  const handleClose = () => {
    setAddNew(false);
    setEdit(false);
    setFormData({});
    handleEventList();
  };
  const handleEdit = (data) => {
    setFormData(data);
    setView(false);
    setEdit(true);
    setAddNew(true);
  };
  const handleView = (data) => {
    setAddNew(true);
    setFormData(data);
    setView(true);
  };

  // const handleViewFiles = (row) => {
  //   if (row?.banner_image) {
  //     window.open(row.banner_image, "_blank");
  //   }
  //   if (row?.file_name) {
  //     window.open(row.file_name, "_blank");
  //   }
  // };
  //for delete
  const handleDelete = (data) => {
    setActiveData(data);
    setOpenAction(true);
  };
  const handleCancelDelete = () => {
    setOpenAction(false);
  };
  const handleDeleteConfirm = (data) => {
    setOpenAction(false);
    setIsActive(true);
    admin_banner_delete(data.uuid)
      .then((res) => {
        setSnackMessage(res.message);
        setIsActive(false);
        setIsSnackError(false);
        setSnackOpen(true);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setIsActive(false);
        setSnackOpen(true);
      });
  };
  /////////////////////
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleEventList();
    }
  };
  return (
    <div>
      <Loader open={isActive} />
      <div className="view-container">
        <h6>
          <b>Banner Images</b>
        </h6>
        <hr />
        {adminType === 1 && (
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={(e) => handleAddNew(e)}
          >
            Add New
          </button>
        )}

        <CustomTable
          {...props}
          columns={[
            { title: "SI No", type: "dynId" },
            {
              title: "Banner Image/Video",
              field: "banner_image",
              render: (rowData) => {
                const bannerFile = rowData?.banner_image;
                if (!bannerFile) return "-";
                
                const absoluteUrl = bannerFile.startsWith("http")
                  ? bannerFile
                  : `${assetBaseUrl}/${bannerFile}`;
                
                const isVideo = bannerFile.match(/\.(mp4|mov|webm|mkv|avi)$/i);
                
                if (isVideo) {
                  return (
                    <a
                      className="break_link"
                      onClick={(e) => window.open(absoluteUrl, "_blank")}
                    >
                      View Video
                    </a>
                  );
                } else {
                  return (
                    <img
                      src={absoluteUrl}
                      alt="banner"
                      style={{ width: "100px", height: "auto" }}
                    />
                  );
                }
              },
            },
            { title: "Heading", field: "banner_main_text_en" },
            { title: "Highlight", field: "banner_highlight_text_en" },
            { title: "Location", field: "banner_location_text_en" },
          ]}
          data={data}
          actions={
            adminType === 2
              ? [
                  { type: "view", handleClick: handleView },
                  // { type: "download", handleClick: handleViewFiles },
                  { type: "edit", handleClick: handleEdit },
                  { type: "delete", handleClick: handleDelete },
                ]
              : [
                  { type: "view", handleClick: handleView },
                  // { type: "download", handleClick: handleViewFiles },
                  { type: "edit", handleClick: handleEdit },
                ]
          }
        />
      </div>
      {addNew && (
        <ManageBanner
          open={addNew}
          edit={edit}
          view={view}
          handleClose={handleClose}
          formData={formData}
        />
      )}
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      {/* //for delete */}
      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete Banner ?"
          data={activeData}
          message="Are you sure to Delete this Banner?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
      {/* /////////////////// */}
    </div>
  );
}
